<template>
  <div class="businessGroup">
    <div class="page-header form-wrap" v-if="!formConfig.hideHeader">
      <div>
        <div class="form-box">
          <slot name="form"></slot>
        </div>
        <a-form v-if="formConfig.formShow" :form="form" layout="inline" @submit="submit">
          <template v-if="formConfig.timeShow">
            <a-form-item>
              <a-date-picker :initialValue="moment(new Date())" :format="dateFormat"
                :disabled-date="startDateDisabledDate" @change="startDateChange" v-decorator="['startDate']"
                style="vertical-align: middle; width: 150px; margin-right: 10px" />
            </a-form-item>
            <a-form-item>
              <a-date-picker v-decorator="['endDate']" :disabled-date="disabledDate" :initialValue="moment(new Date())"
                :format="dateFormat" style="vertical-align: middle; width: 150px; margin-right: 10px" />
            </a-form-item>
          </template>
          <slot name="formSlot"></slot>
          <a-form-item>
            <a-button type="primary" html-type="submit">查询</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" ghost @click="resetFields">清空</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="formRight">
        <slot name="formRight"></slot>
      </div>
    </div>
    <div class="page-main">
      <!-- 表格上方操作区域 -->
      <div class="table-action-bar" v-if="$slots.tableAction">
        <slot name="tableAction"></slot>
      </div>
      <my-table v-bind="{ ...$attrs, ...tableConfig }" :loading="tableLoading" :pagination="false" :total="total"
        @change="handleTableChange" :scroll="{ x: tableWidth }" :dataSource="dataSource" ref="myTab">
        <template v-for="column in tableConfig.columns"
          :slot="column.scopedSlots ? column.scopedSlots.customRender : ''" slot-scope="record">
          <div :class="column.scopedSlots.customRender || ''">
            <slot :name="column.scopedSlots ? column.scopedSlots.customRender : ''" v-bind="record"></slot>
          </div>
        </template>
      </my-table>
      <div class="page">
        <a-pagination v-model="current" :total="total" :pageSize="pageSize" show-less-items show-size-changer
          :page-size-options="['10', '20', '50', '100', '200']" :show-total="total => `共 ${total} 条`"
          @change="handlePageChange" @showSizeChange="handleSizeChange" />
      </div>
    </div>
  </div>
</template>

<script>
import myForm from "@/components/business/Form/myForm";
import myTable from "@/components/business/Table/myTable";
// import queryTable from "./Table/queryTable";
import formSkeleton from "@/components/business/Form/formSkeleton";
import moment from "moment";

const initial = {
  pageSize: 10,
  current: 1,
  total: 0
};

export default {
  name: "businessGroup",
  computed: {
    tableLoading() {
      return this.tableConfig?.loading || this.loading || this.pageLoading;
    },
    tableWidth() {
      const { columns } = this.tableConfig;
      return columns.reduce((acc, cur) => {
        const width = cur?.width || 180;
        return (acc += Number(width));
      }, 0);
    }
  },
  components: {
    myForm,
    myTable,
    formSkeleton
    // queryTable
  },
  props: {
    tableConfig: {
      type: Object,
      default: () => {
      }
    },
    formConfig: {
      type: Object,
      default: () => ({
        formShow: true
      })
    },
    formValues: {
      type: Object,
      default: () => {
      }
    },
    refresh: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.getData();
  },
  data() {
    return {
      ...initial,
      query: {},
      // loading: false,
      dateFormat: this.$root.$data.dateFormat,
      form: this.$form.createForm(this, { name: "businessGroupForm" }),
      // refresh: false,
      pageLoading: false,
      dataSource: []
    };
  },
  methods: {
    moment,
    submit(e) {
      e?.preventDefault();
      this.form.validateFields((error, values) => {
        if (error) return false;
        const { startDate, endDate } = values;
        const { startDateTime, endDateTime } = values;
        const startDateTimeStr = startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : undefined;
        const endDateTimeStr = startDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : undefined;
        this.query = {
          ...values,
          startDateTime: startDateTimeStr ? encodeURIComponent(startDateTimeStr) : undefined,
          endDateTime: endDateTimeStr ? encodeURIComponent(endDateTimeStr) : undefined,
          startDate: startDate ? moment(startDate).format(this.dateFormat) : undefined,
          endDate: endDate ? moment(endDate).format(this.dateFormat) : undefined
        };
        // this.refresh = !this.refresh;
        // this.$refs.myTab.backOne();
        this.current = 1;
        // this.tableConfig.pagination.current = 1
        this.getData();
        this.$emit("form-submit", this.query);
      });
    },
    resetFields() {
      this.startDate = "";
      this.form.resetFields();
      this.submit();
      // this.$emit("handle-submit", {});
    },
    disabledDate(endValue) {
      const startValue = this.startDate;
      if (!startValue) {
        return endValue.valueOf() > moment();
      }
      // 如果有开始时间  结束时间不能大于开始时间和当天
      return endValue.valueOf() < moment(this.startDate).valueOf() || endValue.valueOf() > moment();
    },
    startDateDisabledDate(current) {
      // Can not select days before today and today
      return current && current > moment();
    },
    startDateChange(val) {
      this.startDate = moment(val).format(this.dateFormat);
      this.form.setFieldsValue({
        endDate: undefined
      });
    },
    getData: async function () {
      if (this.pageLoading) return false;
      const url = this.tableConfig?.url;

      const urlType = this.tableConfig?.urlType;

      if (!url) return false;
      const { current, pageSize } = this || initial;
      this.pageLoading = true;


      let res = {};
      if (urlType == "api") {
        res = await this.$post(url, {
          ...(this.query || {}),
          ...(this.formValues || {}),
          pageNo: current,
          pageSize: pageSize
        }, "json", null, urlType);
      } else {
        res = await this.$get(url, {
          ...(this.query || {}),
          ...(this.formValues || {}),
          pageNo: current,
          pageSize: pageSize
        });
      }

      setTimeout(() => {
        this.pageLoading = false;
      }, 800);
      this.dataSource = res?.resultData?.records || [];
      const pagination = this.tableConfig?.pagination;
      this.tableConfig.pagination = {
        ...(pagination || {}),
        total: res?.resultData?.totalNum ? res?.resultData?.totalNum : res?.resultData?.total
      };
      this.total = res?.resultData?.totalNum ? res?.resultData?.totalNum : res?.resultData?.total;
    },
    handleTableChange(page, pageSize) {
      this.current = page || 1;
      this.pageSize = pageSize || 10;
      //this.tableConfig.pagination.current = this.current;
      this.getData();
    },
    // 页码变化处理
    handlePageChange(page, pageSize) {
      this.current = page;
      this.pageSize = pageSize;
      this.getData();
    },
    // 每页显示条数变化处理
    handleSizeChange(current, size) {
      this.current = 1; // 改变每页条数时，重置到第一页
      this.pageSize = size;
      this.getData();
    }
  }
  // computed: {
  //   refreshData() {
  //     this.getData();
  //     return this.refresh;
  //   }
  // }
};
</script>

<style lang="less">
.businessGroup {
  .form-wrap {
    margin: 15px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .action {
    cursor: pointer;
    color: #2a82e4;
    display: flex;
    justify-content: space-around;
    flex-wrap: nowrap;

    .ant-btn {
      padding: 0 !important;
    }
  }

  // 表格上方操作区域样式
  .table-action-bar {
    margin-bottom: 10px;
    padding: 10px 0;
  }

  .page {
    padding: 10px;
    display: flex;
    flex-direction: row-reverse;
  }
}
</style>